import { MissionListPage } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

interface ListingFilters {
  missionsDocumentIds?: string[];
  searchTerm?: string;
  keyStages?: string[];
  characterTraits?: string[];
  locations?: string[];
}

interface MissionListingState {
  filters: ListingFilters;
  totalCountWithoutFilters?: number | null;
  updateTotalCountWithoutFilters: (total: number) => void;
  missionListPage: MissionListPage | null;
  updateFilters: (filters: ListingFilters) => void;
  setMissionListPage: (missionListPage: MissionListPage) => void;
  handleToggleFilter: (field: keyof ListingFilters, value: string) => void;
}

export const useMissionListingStore = create<MissionListingState>((set, get) => ({
  filters: {
    missionsDocumentIds: [],
    searchTerm: '',
    keyStages: [],
    totalCountWithoutFilters: null,
    characterTraits: [],
    locations: [],
  },
  missionListPage: null,
  setMissionListPage: (missionListPage: MissionListPage) => {
    set({ missionListPage });
  },
  updateFilters: (filters: ListingFilters) => {
    set({ filters });
  },
  updateTotalCountWithoutFilters: (total: number) => {
    set({ totalCountWithoutFilters: total });
  },
  handleToggleFilter: (field: keyof ListingFilters, value: string) => {
    const filters = get().filters;
    const currentArray = (filters[field] as string[]) || [];
    const isSelected = currentArray.includes(value);
    const newArray = isSelected ? currentArray.filter((item) => item !== value) : [...currentArray, value];
    const newFilters = { ...filters, [field]: newArray };
    set({ filters: newFilters });
  },
}));
